export default function cardWidgetMap() {
  const widgetName = 'cardWidgetMap';
  const widgetOpts = cardWidgetMapOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: false,
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: [], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 1,
    moreButton: false,
    scriptPath: widgetOpts.scriptPath,
    showDescription: false,
    textOverImage: true,
    cardWidgetLoaded: function (data, _owl, hasData) {
      createMapButton();
      if (hasData) {
        $(`#${widgetName} .card-content`).remove();
      } else {
        $(`#${widgetName}`).remove();
      }
    },
  });
  function createMapButton() {
    const cardhref = $('.standAloneDirections');
    cardhref.addClass('button');
    cardhref.text('Get Directions');

    $('.cardWidgetMap-container').append(cardhref);
  }
}
